export const DrillDownRoute = {
  DRILLDOWNS: 'drilldowns',
};

export const DrillDownPathName = {
  DRILLDOWNS: 'drilldowns',
};
